module.exports = __webpack_public_path__ + "718efd9e73c058d5841d429ccf8977ef.svg";